import * as filters from '@/filters'
import { dayJs as dayjs } from '@/plugins/Dayjs.ts'
import $collections from 'constants/collections.ts'
import type { App } from 'vue'
import Func from 'helpers/Func.js'

export function registerGlobalProperties(app: App) {
	app.config.globalProperties.$hpMoment = dayjs
	app.config.globalProperties.$filter = filters
	app.config.globalProperties.$collections = $collections
	app.config.globalProperties.$func = Func
}
